export default (number) => {
  const dotToComma = number.toFixed(2).replace('.', ',');
  return dotToComma.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};
